import { createFileRoute, redirect } from "@tanstack/react-router";
import { HomePage } from "@/features/home/HomePage";
import { useAuthStore } from "@/stores/auth";
import { useInstanceStore } from "@/stores/instance";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // Anonymous visitors on open instances go to /explore instead of the editor.
    const instance = useInstanceStore.getState();
    if (instance.status === "idle") await instance.load();
    const auth = useAuthStore.getState();
    if (auth.status === "unknown") await auth.restore();
    if (useInstanceStore.getState().profile?.needsSetup) {
      throw redirect({ to: "/auth/signup", replace: true });
    }
    if (useAuthStore.getState().status !== "authenticated") {
      throw redirect({ to: "/explore", replace: true });
    }
  },
  component: HomePage,
});
